export const REDUCER_CV = 'cvsReducer';
export const CVS_API = 'cvsApi';
export const ACTION_RESET_FILTERS = 'resetFilters';
export const ACTION_SET_FILTERS = 'setFilters';
export const ACTION_SET_SEARCH = 'setSearch';
